import { useGetEcSiteOrdersSystemTypes } from '@/hooks/features/ecSiteOrders'
import { useSystemTypesMaster } from '@/stores'

export const useCheckSystemTypesForImportMaster = () => {
  const { systemTypesMaster, setSystemTypesMaster } = useSystemTypesMaster()

  const systemTypesQuery = useGetEcSiteOrdersSystemTypes({
    queryParams: {
      yahooType: 'separated',
    },
    config: {
      enabled: systemTypesMaster.forImport.length === 0,
      onSuccess: ({ systemTypeList }) => {
        setSystemTypesMaster((currVal) => {
          return {
            ...currVal,
            forImport: systemTypeList,
          }
        })
      },
    },
  })

  if (systemTypesMaster.forImport.length > 0) {
    return { isStored: true, isLoading: false }
  }

  return systemTypesQuery.isLoading
    ? {
        isStored: false,
        isLoading: true,
      }
    : {
        isStored: systemTypesQuery.isSuccess,
        isLoading: false,
      }
}
